import Image from 'next/image'

export default function Footer() {
  return (
    <footer
      className="border-t border-border flex flex-col items-start gap-4 px-6 py-5 md:flex-row md:items-center md:justify-between md:px-10 md:py-6 lg:px-[72px] lg:py-7"
    >
      <div className="flex-shrink-0">
        <Image
          src="/logo.webp"
          alt="Deep Pockets"
          width={112}
          height={28}
          className="h-7 w-auto object-contain block"
        />
      </div>

      <p className="text-xs text-white/30 tracking-[0.5px]">
        © {new Date().getFullYear()} Deep Pockets. All rights reserved.
      </p>
    </footer>
  )
}
